import axiosActionsFactory from '../axiosHelpers';
import { UrlService } from '../../../services';

export const GET_LAST_TELEMATIC_CREATION_ATTEMPT = axiosActionsFactory(
  'GET_LAST_TELEMATIC_CREATION_ATTEMPT',
);

export const fetchLastTelematicCreationAttempt = (contextCompanyId) => ({
  type: GET_LAST_TELEMATIC_CREATION_ATTEMPT.START,
  payload: {
    request: {
      url: UrlService.inboundTelematicLastCreationAttempt(),
      params: { contextCompanyId },
    },
  },
});
